import { ISchedulesTableInitialState } from '@types';

export const initialSchedules = (): ISchedulesTableInitialState => {
    return { schedulesTableList: null, vehicle: null };
};
